import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bgImg from "../../../assets/images/Texture BG.jpg";
import ownerImg from "../../../assets/images/Register Owner Image.png";
import logo from "../../../assets/images/86294Sized_AdVendoo_falt_RK_01.png";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEyeSlash } from "react-icons/fa";
import { register } from "../../../api/user.api";
import { errorMsg, success } from "../../../utils/notifications";

function OwnerRegister() {
  const initialData = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  };
  const [ownerFormData, setOwnerFormData] = useState(initialData);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Track loading state
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleTogglePassword = (fieldName) => {
    if (fieldName === "password") {
      setShowPassword(!showPassword);
    } else if (fieldName === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const handleChange = (e) => {
    setOwnerFormData({
      ...ownerFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (ownerFormData.password !== ownerFormData.confirmPassword) {
      errorMsg("Try Again", "Passwords do not match");
      return;
    }

    const formDataWithRole = {
      ...ownerFormData,
      role: "partner",
    };

    setLoading(true);

    register(formDataWithRole)
      .then((res) => {
        localStorage.setItem("token", res?.data?.token);
        setOwnerFormData(initialData);

        // ✅ Show success popup just like company signup
        success(
          "Success",
          "Account created successfully. Email has been sent!"
        );

        navigate("/");
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Something went wrong";
        errorMsg("Oops", errorMessage);
      })

      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-12">
        <div className="min-h-screen col-span-12 lg:col-span-6 md:col-span-12">
          <div className="pt-8">
            <img className="ml-12 h-10 w-auto" src={logo} alt="Your Company" />
          </div>
          <div className="py-5 px-5 flex items-center justify-center h-[90%]">
            <div className="w-4/5">
              <div>
                <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900">
                  Welcome to <span className="text-yellow">AdVendoo</span>
                </h2>
                <p className="text-base leading-6 text-gray-400 font-semibold">
                  Register your account?
                </p>
              </div>

              <div className="mt-5">
                <form onSubmit={handleSubmit} method="POST">
                  <div className="pb-4">
                    <div className="grid grid-cols-1 gap-x-6 gap-y-3.5 sm:grid-cols-6">
                      <div className="sm:col-span-3">
                        <label
                          htmlFor="firstName"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          First name
                        </label>
                        <div className="mt-2">
                          <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={ownerFormData.firstName}
                            onChange={handleChange}
                            id="first-name"
                            autoComplete="first-name"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-3">
                        <label
                          htmlFor="lastName"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          Last name
                        </label>
                        <div className="mt-2">
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={ownerFormData.lastName}
                            onChange={handleChange}
                            id="lastName"
                            autoComplete="last-name"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-full">
                        <label
                          htmlFor="email"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          Email
                        </label>
                        <div className="mt-2">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Email"
                            value={ownerFormData.email}
                            onChange={handleChange}
                            autoComplete="email"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                            required
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-full">
                        <label
                          htmlFor="phone"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          Phone
                        </label>
                        <div className="mt-2">
                          <input
                            id="phone"
                            name="phone"
                            type="text"
                            value={ownerFormData.phone}
                            onChange={handleChange}
                            placeholder="Phone"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-3 relative">
                        <label
                          htmlFor="password"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          Password
                        </label>
                        <div className="mt-2 relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            value={ownerFormData.password}
                            onChange={handleChange}
                            id="password"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                            required
                          />
                          <button
                            className="absolute inset-y-0 right-0 flex items-center pr-3"
                            onClick={() => handleTogglePassword("password")}
                            type="button"
                          >
                            {showPassword ? (
                              <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                            ) : (
                              <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="sm:col-span-3 relative">
                        <label
                          htmlFor="confirmPassword"
                          className="block text-base font-semibold leading-6 text-gray-800"
                        >
                          Confirm Password
                        </label>
                        <div className="mt-2 relative">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={ownerFormData.confirmPassword}
                            onChange={handleChange}
                            id="confirmPassword"
                            className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellow sm:leading-6"
                            required
                          />
                          <button
                            className="absolute inset-y-0 right-0 flex items-center pr-3"
                            onClick={() =>
                              handleTogglePassword("confirmPassword")
                            }
                            type="button"
                          >
                            {showConfirmPassword ? (
                              <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                            ) : (
                              <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="col-span-full">
                        <div className="flex items-center">
                          <input
                            id="termsAndConditions"
                            name="termsAndConditions"
                            type="checkbox"
                            className="h-4 w-4 rounded border-gray-300 text-yellow focus:ring-yellow"
                            required
                          />
                          <label
                            htmlFor="termsAndConditions"
                            className="ml-3 block text-base font-medium leading-6 text-gray-400"
                          >
                            Agree with{" "}
                            <Link
                              to="https://www.advendoo.com/en_GB/terms-and-conditions"
                              className="underline font-medium text-yellow hover:text-yellow"
                            >
                              Terms and Conditions
                            </Link>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md bg-yellow px-3 py-2.5 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow"
                      disabled={loading}
                    >
                      {loading ? "Processing..." : "Sign Up"}
                    </button>
                    <p className="mt-3 text-base leading-6 text-gray-400">
                      Already have an account?{" "}
                      <Link
                        to="/"
                        className="underline font-medium text-yellow hover:text-yellow"
                      >
                        Login Here
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="h-screen hidden lg:block col-span-12 lg:col-span-6 sm:col-span-12 relative">
          <img
            className="h-full w-full object-cover"
            src={bgImg}
            alt="bg img"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <div className="flex items-center justify-center flex-col">
                <h1 className="w-80 my-4 text-3xl ">
                  Define Your Owner Policy here
                </h1>
                <p className="w-80 mb-5 text-base">
                  In publishing and graphic design, Lorem ipsum is a placeholder
                  text commonly used to demonstrate the visual form of a
                  document the visual form of a document
                </p>
              </div>
              <img className="w-auto h-72" src={ownerImg} alt="bg img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OwnerRegister;
